import { FormControlLabel } from "@material-ui/core";
import { FormEvent, useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import { setTimeout } from "timers";
import Button from "../../../../../components/Button";
import ButtonNavigatorComponent from "../../../../../components/ButtonNavigator";
import IconButton from "../../../../../components/IconButton";
import Input from "../../../../../components/Input";
import InputSelect from "../../../../../components/Input-select";
import { ModalPopUp } from "../../../../../components/ModalPopUp";
import { TableComponent, TH, THeadTR } from "../../../../../components/Table v2";
import { toastError, toastSuccess } from "../../../../../components/Toast";
import useAuthData from "../../../../../hook/useAppData";
import { IconEye, IconSwitch, IconTrash } from "../../../../../icons";
import { AutoCompleteList } from "../../../../../libs/autoCompleteList";
import { orderBy } from "../../../../../libs/orderBy";
import { SwitchBlue } from "../../../../../libs/switch";
import { data } from "../Form/constants";
import { IImmobilizedInventory } from "../Form/models";
import { getImmobilized, getImmobilizedById, getImmobilizedFilter, putImmobilized } from "../service";
import { CASE_FILTER, LIST_LOCAL_FILTER, SELECTFILTER, SELECTMODAL, STATUS_LIST_FILTER, THEADERMOCK } from "./constants";
import "./index.scss";

export function ListInventoryImmobilized() {
  const { token } = useAuthData();
  const [filterValue, setFilterValue] = useState("");
  const [selectFilterValue, setSelectFilterValue] = useState(0);
  const [selectFilter, setSelectFilter] = useState(0);
  const [selectFilterStatus, setSelectFilterStatus] = useState(0);
  const [page, setPage] = useState(1);
  const [selectSize, setSelectSize] = useState(10);
  const [listImmobilized, setListImmobilized] = useState([]);
  const [needSpinner, setNeedSpinner] = useState(true);
  const [nameItem, setNameItem] = useState("");
  const [totalItens, setTotalItens] = useState("");
  let total = 0;

  const [inactiveOrActive, setInactiveOrActive] = useState(false);
  const [imobilizedActived, setImobilizedActived] = useState<IImmobilizedInventory[]>();
  const [imobilizedInactived, setImobilizedInactived] = useState<IImmobilizedInventory[]>();

  const [needModalPopUp, setNeedModalPopUp] = useState({
    status: false,
    id: 0,
  });

  const [orderSwitch, setOrderSwitch] = useState(true);

  useEffect(() => {
    getImobilized();
  }, []);

  useEffect(() => {
    renderizar();
  }, [imobilizedActived, imobilizedInactived, inactiveOrActive]);

  useEffect(() => {
    if (listImmobilized?.length) setNeedSpinner(false);
    else {
      setTimeout(() => {
        setNeedSpinner(false);
      }, 500);
    }
  }, [listImmobilized]);

  function renderizar() {
    return inactiveOrActive ? imobilizedInactived : imobilizedActived;
  }

  function getTotalItensInactives(list: IImmobilizedInventory[]) {
    let total = 0;
    list?.forEach((item) => {
      if (item?.isDeleted) total += +item?.purchase_amount;
    });
    return total;
  }

  async function getImobilized() {
    const data = await getImmobilized(token);
    setListImmobilized(data?.furniture);
    setTotalItens(data?.total);
    const [imobilizedActive, imobilizedInactive] = separateActiveFromInactiveImobilized(data?.furniture);
    setImobilizedActived(imobilizedActive);
    setImobilizedInactived(imobilizedInactive);
  }

  function separateActiveFromInactiveImobilized(list?: IImmobilizedInventory[]) {
    const listImobilized = list;
    const active = listImobilized?.filter((item) => Boolean(!item.isDeleted));
    const inactive = listImobilized?.filter((item) => Boolean(item.isDeleted));
    return [active, inactive];
  }

  function listRenderObserverThePage(indexOfLine: number) {
    const initialListRender = indexOfLine < (page + 1) * selectSize;
    const endListRender = indexOfLine >= page * selectSize;
    return initialListRender && endListRender;
  }

  function exitPopUp() {
    return setNeedModalPopUp({ status: false, id: 0 });
  }

  function ModalExitContent(props) {
    const [defaultValues, setDefaultValues] = useState(data as IImmobilizedInventory);
    const [selectValue, setSelectValue] = useState(0);
    const setNameItem = props.setNameItem;

    useEffect(() => {
      getImobilizedById();
    }, []);

    async function getImobilizedById() {
      const data = await getImmobilizedById(needModalPopUp.id, token);
      const dataTrated: IImmobilizedInventory = {
        ...data,
        observation: "",
      };
      if (dataTrated.status === "Doado") setSelectValue(1);
      if (dataTrated.status === "Vendido") setSelectValue(2);
      setNameItem(dataTrated?.name);
      setDefaultValues(dataTrated);
    }

    function saveDataOfField(event) {
      let { value, name } = event;
      setDefaultValues({ ...defaultValues, [`${name}`]: value });
    }

    function handleSubmit(event: FormEvent) {
      event.preventDefault();
      if (selectValue != 1 && selectValue != 2) return toastError("Status não selecionado");

      const data = {
        ...defaultValues,
        status: verifyValueSelect(),
        isDeleted: true,
      };
      updateData(data);
    }

    async function updateData(obj) {
      const res = await putImmobilized(needModalPopUp.id, obj, token);
      verifyRes(res);
    }

    function verifyRes(res) {
      if (res.ok) {
        toastSuccess(`item ${verifyValueSelect()}, este item foi inativado!`);
        setTimeout(() => {
          getImobilized();
          return setNeedModalPopUp({ status: false, id: 0 });
        }, 1000);
      } else {
        return toastError("erro ao inativar");
      }
    }

    function verifyValueSelect() {
      if (selectValue == 1) return "Doado";
      if (selectValue == 2) return "Vendido";
    }

    const formClassNames = {
      divButton: "btnContainer justify-start div-btn-modal-immobilized div-history-filter-btn width-100",
      form: "box-form min-height-none modalPopUpBodyContainer",
    };

    return (
      <>
        <Toaster />
        <form onSubmit={handleSubmit} className={formClassNames.form}>
          <div className="div-input-modal-immobilized">
            <Input
              className="input-modal-immobilized"
              name="observation"
              label="Digite uma Observação"
              placeholder="Observação"
              value={defaultValues?.observation}
              setValue={(event) => saveDataOfField(event.target)}
            />
            <InputSelect
              className="inputContainer select-modal-immobilized"
              name="status"
              label="Status"
              placeholder="Status"
              value={selectValue}
              onChange={(event) => setSelectValue(event.target.value)}
              list={SELECTMODAL}
            />
          </div>
          <div className={formClassNames.divButton}>
            <button type="submit" className="btn filter-btn history-filter-btn bg-primary">
              Salvar
            </button>
            <button className="Link btn  history-filter-btn bg-secondary" onClick={() => setNeedModalPopUp({ status: false, id: 0 })}>
              Cancelar
            </button>
          </div>
        </form>
      </>
    );
  }

  function TotalScreenItems() {
    const classSpan = "font-source-sans-pro color-text bold";
    function whatTotal() {
      return !inactiveOrActive ? totalItens : String(getTotalItensInactives(listImmobilized));
    }
    return (
      <>
        <span className={classSpan}>total em tela: {total?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</span>
        <span className={classSpan}>
          total: {Number(whatTotal().replaceAll(",", "."))?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
        </span>
      </>
    );
  }

  async function handleFilterImmobilized() {
    const SELECT_STATUS_NAME = STATUS_LIST_FILTER[selectFilterStatus - 1]?.name;
    const FILTERED_BY = CASE_FILTER[selectFilter - 1];

    let queryString = "?";
    if (filterValue) queryString += `${FILTERED_BY}=${filterValue}&`;
    if (selectFilterStatus) queryString += `status=${SELECT_STATUS_NAME}`;

    if (SELECT_STATUS_NAME === "Doado" || SELECT_STATUS_NAME === "Vendido") setInactiveOrActive(true);
    else setInactiveOrActive(false);

    const listFilter = await getImmobilizedFilter(token, queryString);
    const [imobilizedActive, imobilizedInactive] = separateActiveFromInactiveImobilized(listFilter?.furniture);
    setImobilizedActived(imobilizedActive);
    setImobilizedInactived(imobilizedInactive);
  }

  function handleCleanFilter() {
    setFilterValue("");
    setSelectFilter(0);
    setSelectFilterStatus(0);
    getImobilized();
  }

  //switch control inactive active
  function setStateFunction() {
    setInactiveOrActive((oldState) => !oldState);
    setPage(0);
  }

  function handleOrderList(label: string) {
    orderSwitch ? setImobilizedActived(orderBy(imobilizedActived, label, "asc")) : setImobilizedActived(orderBy(imobilizedActived, label, "desc"));
    orderSwitch
      ? setImobilizedInactived(orderBy(imobilizedInactived, label, "asc"))
      : setImobilizedInactived(orderBy(imobilizedInactived, label, "desc"));
    setOrderSwitch((oldState: boolean) => !oldState);
    renderizar();
    setPage(0);
  }

  return (
    <>
      <datalist id="dataList">
        {AutoCompleteList(inactiveOrActive ? imobilizedInactived : imobilizedActived, [CASE_FILTER[selectFilter - 1]])?.map((item) => {
          return (
            <option key={item} value={item}>
              {item}
            </option>
          );
        })}
      </datalist>

      <ModalPopUp status={needModalPopUp.status} onClickCancel={exitPopUp} title={nameItem}>
        <ModalExitContent setNameItem={setNameItem} />
      </ModalPopUp>
      <div className="margin-screen collaboratorContainerListCenter">
        <div className="box-title">
          <h1 className="font-poppins">Inventário - Imobilizados {inactiveOrActive ? "| Inativo" : "| Ativo"}</h1>
          <Link className="btn bg-primary Link" to="/immobilized-inventory/form">
            {" "}
            Adicionar Item
          </Link>
        </div>
        <div className="filterContainer max-width-none">
          <div className="rowFilterContainer max-width-none">
            {SELECTFILTER[selectFilter - 1]?.name === "Local" ? (
              <InputSelect
                className="select-filer-immobilized"
                name="search"
                label="Buscar"
                placeholder="Escolher uma Opção"
                value={selectFilterValue}
                onChange={(event: any) => {
                  setFilterValue(LIST_LOCAL_FILTER[event.target.value - 1]?.name);
                  setSelectFilterValue(event.target.value);
                }}
                list={LIST_LOCAL_FILTER}
              />
            ) : (
              <Input
                className={`-ml-4 input-filter-immobilized`}
                name="immobilized"
                type="search"
                label="Buscar"
                placeholder="Busque um bem"
                value={filterValue}
                setValue={(event: any) => setFilterValue(event.target.value)}
                disabled={!!!selectFilter}
                list="dataList"
              />
            )}
            <InputSelect
              className="select-filter-immobilized"
              name="search"
              label="Filtro"
              placeholder="Pesquisar"
              value={selectFilter}
              onChange={(event: any) => setSelectFilter(event.target.value)}
              list={SELECTFILTER}
            />
            <InputSelect
              className="select-filter-immobilized"
              name="searchStatus"
              label="Status"
              placeholder="Tipo de Status"
              value={selectFilterStatus}
              onChange={(event) => setSelectFilterStatus(event.target.value)}
              list={STATUS_LIST_FILTER}
            />
            <div className="divButtonFilterImmobilized flex btnContainer align-end">
              <Button className="bg-primary" onClick={handleFilterImmobilized}>
                Filtrar
              </Button>
              <button className="Link btn bg-secondary" onClick={handleCleanFilter}>
                Limpar
              </button>
            </div>
          </div>

          <div className="flex center">
            <FormControlLabel
              className="switch switch-collaborator m-top10"
              control={<SwitchBlue checked={inactiveOrActive} onChange={setStateFunction} name="checkedB" />}
              label="ver inativos"
            />
          </div>
        </div>

        <TableComponent>
          {!!renderizar()?.length ? (
            <THeadTR>
              {THEADERMOCK?.map((header) => {
                return (
                  <TH>
                    <div className="wrapperTheader">
                      <span>{header.name}</span>
                      <IconButton className="center row-trash icon-trash" icon={IconSwitch} onClick={() => handleOrderList(header.value)} />
                    </div>
                  </TH>
                );
              })}
              {!!renderizar()?.length && (
                <>
                  <th>Editar</th>
                  <th>Ações</th>
                </>
              )}
            </THeadTR>
          ) : (
            <div className="nothing-list flex justify-center width-100">
              <h1>Não há registros para a busca realizada.</h1>
            </div>
          )}
          <tbody>
            {renderizar()?.map((item: IImmobilizedInventory, index) => {
              return (
                listRenderObserverThePage(index) &&
                ((total += Number(item.purchase_amount)),
                (
                  <tr className={`"collaboratorTableRow"`} key={item.id}>
                    <td>{item?.name}</td>
                    <td>{item?.asset_number}</td>
                    <td>{item?.status}</td>
                    <td>{item?.physical_location}</td>
                    <td>{item?.responsible}</td>
                    <td>{Number(item?.purchase_amount).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                    <td className="col-function">
                      <IconButton className="center row-edit" icon={IconEye} url={`/immobilized-inventory/form/${item?.id}`} />
                    </td>
                    <td className="row-trash">
                      <IconButton
                        className="center row-trash icon-trash"
                        icon={IconTrash}
                        onClick={() => setNeedModalPopUp({ status: true, id: Number(item?.id) })}
                      />
                    </td>
                  </tr>
                ))
              );
            })}
          </tbody>

          {/* <tr>
              <td colSpan={4}>Total</td>
              <td colSpan={3}>{total?.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
            </tr> */}
        </TableComponent>
        {renderizar()?.length ? (
          <ButtonNavigatorComponent
            className="width-select-size"
            list={renderizar()}
            page={page}
            setPage={setPage}
            selectSize={selectSize}
            setSelectSize={setSelectSize}
            ExtraContent={() => TotalScreenItems()}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
}
